<ng-container *ngIf="form">

  <div class="externalFormConfigurationContainer">


    <div class="configurationDetailsWrapper">

      <mat-expansion-panel class="detailsCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
        [expanded]="screenWidth > 768">
        <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
          <mat-panel-title>Dettagli</mat-panel-title>
        </mat-expansion-panel-header>


        <div class="detailsRow">

          <div class="two fields">

            <div class="field">
              <mat-form-field appearance="outline">
                <mat-label>Facebook Id</mat-label>
                <input validatorColor name="descrizione" matInput type="text" [formControl]="form!.controls.formId" spellcheck="false"
                  autocomplete="false">
              </mat-form-field>
            </div>

            <div class="field">
              <mat-form-field appearance="outline">
                <mat-label>Nome</mat-label>
                <input validatorColor name="descrizione" matInput type="text" [formControl]="form!.controls.formName"
                  spellcheck="false" autocomplete="false">
              </mat-form-field>
            </div>

          </div>

          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Descrizione</mat-label>
              <input validatorColor name="descrizione" matInput type="text" [formControl]="form!.controls.description"
                spellcheck="false" autocomplete="false">
            </mat-form-field>
          </div>

          <div class="field">
            <div style="margin-bottom: 1rem;">
              <mat-slide-toggle [formControl]="form!.controls.isEnabled">Abilitato</mat-slide-toggle>
            </div>
          </div>

        </div>
      </mat-expansion-panel>

      <mat-expansion-panel class="detailsCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
        [expanded]="screenWidth > 768">
        <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
          <mat-panel-title>Channel</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="detailsRow">

          <div class="fields">

            <div class="field">
              <autocomplete class="wide-field" [inputHtmlId]="'injectorInput'" [inputControl]="form!.controls.injector"
                [autocompleteStrategy]="injectorIdSuggestionService" [label]="'Injector'"
                [placeHolder]="'cerca lead injector'" [loadOnClick]="true"
                (selectedSuggestion)="onSelectedInjectorSuggestion($event)"></autocomplete>

              <button *ngIf="!form.dirty &&  !isCreatingNewForm" (click)="onLeadInjectorInfoClick()" mat-icon-button>
                <mat-icon>info</mat-icon>
              </button>
            </div>
          </div>

        </div>

      </mat-expansion-panel>

    </div>

    <div class="actionContainer" *ngIf="!readOnly">
      <div class="detail-row">
        <div class="right">
          <button (click)="onCancelClick()" mat-stroked-button type="button">Annulla</button>
          <button name="salva" [disabled]="!form!.dirty || !form!.valid" color="warn" mat-flat-button
            (click)="onSaveClick()">Salva</button>
          <button *ngIf="canDelete && !isCreatingNewForm" name="delete" color="warn" mat-flat-button
            (click)="onDeleteClick()">Elimina</button>
        </div>
      </div>
    </div>

  </div>


</ng-container>
